import { ReactNode } from 'react';
import { BRAND_LOGO_MAPPING } from './logos';
import { Brand } from '@axo/config/@types/Brand.types';

interface BrandLogoProps {
  brand?: Brand;
  fallback?: ReactNode;
  className?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  brand,
  className,
  fallback,
}) => {
  const logoSrc = brand ? BRAND_LOGO_MAPPING[brand] : undefined;

  if (!logoSrc && fallback !== undefined) {
    return fallback;
  }

  return (
    <img src={logoSrc} className={className} aria-label={`Brand ${brand}`} />
  );
};
